import script from "./InsufficientCreditsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InsufficientCreditsModal.vue?vue&type=script&setup=true&lang=js"

import "./InsufficientCreditsModal.vue?vue&type=style&index=0&id=82f71a02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f71a02"]])

export default __exports__